export const robSurveyDefaultValues = {
  bunker: {
    barge: {
      volume15: '',
    },
    bargeKind: '',
    bdn: {
      density15: '',
      volume15: '',
    },
    fuelGradePerBdn: '',
    volume15CPerVsl: '',
  },
  fuelTanks: {},
  general: {
    fuelSludgeBilgeAndComments: {},
    seals: {
      afterBunkering: {
        portside: {
          hfo: { seal1: '', seal2: '' },
          mdo: { seal1: '', seal2: '' },
          sludge: { seal1: '', seal2: '' },
          ulsfo: { seal1: '', seal2: '' },
          vlsfo: { seal1: '', seal2: '' },
        },
        starboard: {
          hfo: { seal1: '', seal2: '' },
          mdo: { seal1: '', seal2: '' },
          sludge: { seal1: '', seal2: '' },
          ulsfo: { seal1: '', seal2: '' },
          vlsfo: { seal1: '', seal2: '' },
        },
      },
      beforeBunkering: {
        portside: {
          hfo: { seal1: '', seal2: '' },
          mdo: { seal1: '', seal2: '' },
          sludge: { seal1: '', seal2: '' },
          ulsfo: { seal1: '', seal2: '' },
          vlsfo: { seal1: '', seal2: '' },
        },
        starboard: {
          hfo: { seal1: '', seal2: '' },
          mdo: { seal1: '', seal2: '' },
          sludge: { seal1: '', seal2: '' },
          ulsfo: { seal1: '', seal2: '' },
          vlsfo: { seal1: '', seal2: '' },
        },
      },
    },
    soundingDraftAndTemperature: {
      draft: {
        aft: { after: '', before: '' },
        fwd: { after: '', before: '' },
        mid: { after: '', before: '' },
      },
      soundingEquipment: {
        soundingTape: { calibrationExpiryDate: '', serialNo: '' },
        thermometer: { calibrationExpiryDate: '', serialNo: '' },
      },
      temperature: {
        engineRoomTemperature: '',
        outsideTemperature: '',
        seawaterTemperature: '',
      },
    },
    surveyLog: {
      initialMeasurementCompleted: '',
      surveyArrivedBerth: '',
      surveyCommenced: '',
      surveyCompleted: '',
      surveyDocumentCompleted: '',
      surveyorBoardedVessel: '',
      surveyorLeftBase: '',
      surveyorLeftVessel: '',
      surveyorReturnedBase: '',
      vesselBerthed: '',
    },
    vesselInfo: {
      city: '',
      companyAddress: '',
      dateOfSurvey: '',
      email: '',
      filledByCrew: false,
      flag: '',
      imoNumber: '',
      nameOfChiefEngineer: '',
      nameOfMaster: '',
      nameOfSurveyor: '',
      owner: '',
      phone: '',
      placeOfSurvey: '',
      shipName: '',
      surveyCompany: '',
      terminalName: '',
      vesselManagement: '',
      voyageNo: '',
    },
  },
  laboratory: {
    bunker: {
      labCompany: '',
      testingCompleted: '',
    },
    isoYear: '',
    remarks: '',
    sampleSeals: {
      supplier: '',
      surveyorVessel: '',
    },
    tests: {
      aluminium: '',
      appearance: '',
      ashContent: '',
      calcium: '',
      ccai: '',
      cetaneIndex: '',
      density15: '',
      fame: '',
      flashpoint: '',
      iron: '',
      lead: '',
      lowHeatingValue: '',
      lubricity: '',
      magnesium: '',
      mcrt10pctResidue: '',
      microCarbonResidue: '',
      netCalorificValue: '',
      nickel: '',
      phosphorous: '',
      potassium: '',
      pourpoint: '',
      silicon: '',
      sodium: '',
      sulphurContent: '',
      totalAcidNumber: '',
      totalSedAccelerated: '',
      totalSedExistent: '',
      totalSedPotential: '',
      vanadium: '',
      viscosity40: '',
      viscosity50: '',
      waterContent: '',
      zinc: '',
    },
  },
  sludgeOilBilge: {},
}
